export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8428.8b9b1c13.jpg";